import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import Timestamp from "components/Timestamp";
import { RepoFile } from "types/generated";

const UpdatedAtCell = ({ item, ...cellProps }: TableSimpleCellProps<RepoFile>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {item.revision.createdAt ? (
        <Timestamp timestamp={item.revision.createdAt} />
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default UpdatedAtCell;
